<template>
  <div>
    <Chart :cdata="config" />
  </div>
</template>

<script>
import Chart from "./chart.vue";
export default {
  props: {
    cdata: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      config: {},
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.getLasttime();
  },
  methods: {
    // 根据自己的业务情况修改
    setData(timeList) {
      this.config = this.cdata;
      this.config.category = timeList;
    },
    getLasttime: function() {
      let date = new Date();
      let hour = date.getHours();
      let timeList = this.setTime(hour, 24);
      this.setData(timeList);
    },
    setTime: function(time, num) {
      let arr = [];
      for (let i = 0; i < num; i++) {
        if (i == 0) {
          arr.push((time + 1) % 24);
        } else {
          arr.push((arr[i - 1] + 1) % 24);
        }
      }
      arr.forEach((e, i) => {
        arr[i] = e + ":00";
      });
      return arr;
    },
  },
};
</script>

<style lang="scss" scoped></style>
